import API from "../../../api";
import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { dataGridStyle, logColor } from "../../../theme";
import ReportIcon from "@mui/icons-material/Report";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const HighDataGrid = ({ names, colors }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        API.getWeeklyDataLecs({ types: [0, 1], queryType: "table" }).then((result) => {
            const newData = [];
            result.data.forEach((item, index) => {

                let lecs = names.find((name) => name.seriale === item.fkSeriale);

                newData.push({
                    id: index,
                    nomeLecs: lecs.nomeLecs || lecs.matricola,
                    matricola: lecs.matricola,
                    dettaglio: item.dettaglio,
                    count: item.count,
                    protocol: item.protocol,
                    app_proto: item.app_proto,
                    tipo: item.tipo
                })
            })
            setData(newData);
        }).catch((err) => {})
    }, [names]);

    const handleRedirect = (event) => {
        API.set_lecs({ serial_number: event.matricola }).then((result) => {
            const today = new Date();
            const oneWeekAgo = new Date();
            oneWeekAgo.setDate(today.getDate() - 7);
            const formatDate = date => date.toISOString().split('T')[0];
            const dateFrom = formatDate(oneWeekAgo);
            const dateTo = formatDate(today);
            
            let url=`exact_details=${encodeURIComponent(event.dettaglio)}`;
            url+=`&dateFrom=${dateFrom}`;
            url+=`&dateTo=${dateTo}`;
            if(event.tipo === 0){
                window.sessionStorage.setItem("selectedTab", "High");
                window.location.href = `/user/security/high?${url}`;
            }else if (event.tipo === 1){
                window.sessionStorage.setItem("selectedTab", "Critical");
                window.location.href = `/user/security/critical?${url}`;
            }
        }).catch((error) => console.error("[handleRedirect] Errore durante il redirect:", error));
    }

    const columns = [
        {
            field: "nomeLecs",
            headerName: "LECS",
            flex: 1,
            maxWidth: 250,
            align: "center",
            headerAlign: "center",
            filterable: true,
        },
        {
            field: "matricola",
            headerName: "MATRICOLA",
            flex: 1,
            maxWidth: 150,
            align: "center",
            headerAlign: "center",
            filterable: true,
        },
        {
            field: "dettaglio",
            headerName: "DETAILS",
            flex: 1,
            align: "center",
            headerAlign: "center",
            filterable: true,
        },
        {
            field: "count",
            headerName: "COUNT",
            maxWidth: 80,
            align: "center",
            headerAlign: "center",
            filterable: false,
        },
        {
            field: "tipo",
            headerName: "TYPE",
            maxWidth: 70,
            align: "center",
            headerAlign: "center",
            filterable: false,
            renderCell: (params) => {
                if (params.value === "critical") {
                    return (<ReportIcon sx={{ color: logColor[1] }} />)
                } else {
                    return (<HighlightOffIcon sx={{ color: logColor[0] }} />)
                }
            }
        },
        {
            align: "center",
            headerAlign: "center",
            maxWidth: 100,
            filterable: false,
            renderCell: (params) => {
                return (
                    <Button onClick={() => handleRedirect(params.row)}>MAIN TABLE</Button>
                )
            }
        }
    ]


    return (
        <Box className="highDataGrid" height={"100%"}>
            <Typography sx={{ fontSize: "20px", mb: 2}}>
                Critical and High Weekly data
            </Typography>
            <DataGridPro
                sx={dataGridStyle}
                columns={columns}
                rows={data}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                    toolbar: {
                        printOptions: { disableToolbarButton: true },
                    },
                }}
            />
        </Box>
    )
}

export default HighDataGrid;